<template>
  <div>
    <Head/>
    <div class="index-banner" :class="{load: banner.length === 0}">
      <div class="swiper-container pic">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="item in banner" :key="item.id">
            <a v-if="item.link !== ''" :href="item.link" target="_blank" rel="nofollow">
              <img class="pc" :src="item.img" alt="">
              <img class="wap" :src="item.img2" alt="">
            </a>
            <a v-else>
              <img class="pc" :src="item.img" alt="">
              <img class="wap" :src="item.img2" alt="">
            </a>
          </div>
        </div>
        <div class="swiper-pagination" v-if="banner.length > 1"></div>
      </div>
      <div class="content ytable" v-if="banner.length > 0 && (bannerData.price1 !== 0 || bannerData.price2 !== 0)">
        <ul class="ul ytable-cell" v-if="lan === 0">
          <li v-if="bannerData.price1 !== 0">
            <div class="tit dot">{{bannerData.title1}}</div>
            <div class="num dot">{{bannerData.price1 | num}}<span> 元</span></div>
          </li>
          <li v-if="bannerData.price2 !== 0">
            <div class="tit dot">{{bannerData.title2}}</div>
            <div class="num dot">{{bannerData.price2 | num}}<span> 元</span></div>
          </li>
        </ul>
        <ul class="ul ytable-cell" v-else-if="lan === 1">
          <li v-if="bannerData.price1 !== 0">
            <div class="tit dot2">{{bannerData.enTitle1}}</div>
            <div class="num dot">{{bannerData.price1 | num}}<span> RMB</span></div>
          </li>
          <li v-if="bannerData.price2 !== 0">
            <div class="tit dot2">{{bannerData.enTitle2}}</div>
            <div class="num dot">{{bannerData.price2 | num}}<span> RMB</span></div>
          </li>
        </ul>
      </div>
    </div>
    <div class="index">
      <div class="auto">
        <ul class="ul clearfix">
          <li v-for="( item, index ) in entrance" :key="index">
            <router-link style="display: block" :to="{name: item.requestTo, query: { columnId: item.id }}">
              <div class="pic bg_cover" :style="'background-image: url(' + item.img + ')'">
                <div class="cover"></div>
              </div>
              <div class="content" v-if="lan === 0">
                <div class="tit dot">{{item.name}}</div>
                <div class="txt dot3">{{item.content}}</div>
              </div>
              <div class="content" v-if="lan === 1">
                <div class="tit">{{item.enName}}</div>
                <div class="txt">{{item.enContent}}</div>
              </div>
              <div class="more" v-if="lan === 0">了解更多</div>
              <div class="more" v-else-if="lan === 1">Learn More</div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <Bottom/>
  </div>
</template>

<script>
// @ is an alias to /src
import Head from '@/components/header'
import Bottom from '@/components/bottom'
import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'Home',
  components: {
    Head,
    Bottom
  },
  filters: {
    num (value) {
      let result = ''
      let counter = 0
      value = (value || 0).toString()
      for (let i = value.length - 1; i >= 0; i--) {
        counter++
        result = value.charAt(i) + result
        if (!(counter % 3) && i !== 0) { result = ',' + result }
      }
      return result
    }
  },
  data () {
    return {
      indexBanner: [],
      banner: [],
      bannerData: [],
      entrance: [],
      menuList: [],
      lan: this.$store.state.isEn
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  mounted () {
    if (localStorage.getItem('routeList') === null) {
      this.$api.post('api/benefitArticleType/queryByParam', { isDelete: 0 }, r => {
        r.data.forEach((item) => {
          if (item.isHome === 1) {
            this.entrance.push(item)
          }
        })
        this.entrance.forEach((item) => {
          if (item.parentId !== 0) {
            item.id = item.parentId
          }
        })
      })
    } else {
      try {
        const meunList = JSON.parse(localStorage.getItem('routeList'))
        meunList.forEach((item) => {
          if (item.isHome === 1) {
            this.entrance.push(item)
          }
          item.children.forEach((inner) => {
            if (inner.isHome === 1) {
              inner.id = inner.parentId
              this.entrance.push(inner)
            }
          })
        })
      } catch (err) {
        console.log(err)
      }
    }
    if (sessionStorage.getItem('banner') === null) {
      this.$api.post('api/benefitAdvert/queryByParam', { articleTypeId: 38, state: 1, isDelete: 0 }, r => {
        if (r.data) {
          const banner = r.data
          this.bannerData = r.data[0]
          this.banner = banner
        } else {
          this.banner = [
            {
              img: require('@/assets/index-banner-pc.jpg'),
              img2: require('@/assets/index-banner-wap.jpg')
            }
          ]
          this.bannerData = {
            price1: 0,
            price2: 0
          }
        }
        this.$nextTick(function () {
          this.init()
        })
      })
    } else {
      try {
        const banner = JSON.parse(sessionStorage.getItem('banner'))
        this.banner = []
        banner.forEach((item) => {
          if (item.articleTypeId === 38) {
            this.banner.push(item)
          }
        })
        this.bannerData = this.banner[0]
        this.$nextTick(function () {
          this.init()
        })
      } catch (e) {
        console.log(e)
      }
    }
  },
  methods: {
    init () {
      /* eslint-disable no-new */
      new Swiper('.swiper-container', {
        pagination: '.swiper-pagination',
        paginationClickable: true,
        autoplay: 3000,
        speed: 1000
      })
    }
  }
}
</script>
<style>
.index-banner{position: relative; min-height: calc(100vw * .42); background-color: rgba(228,0,127,0.2);}
.index-banner .pic,
.index-banner img{width: 100%; min-height: calc(100vw * .42);}
.index-banner .wap{display: none;}
.index-banner .swiper-pagination{width: 100%; bottom: 5%!important;}
.index-banner .swiper-pagination span{margin: auto 10px!important; background: #fff; opacity: 1; width: 10px; height: 10px; vertical-align: middle; box-sizing: border-box;}
.index-banner .swiper-pagination .swiper-pagination-bullet-active{width: 20px; height: 20px; background: none; border: 3px solid rgba(255, 255, 255, .2); position: relative;}
.index-banner .swiper-pagination .swiper-pagination-bullet-active::before{content: ''; left: 50%; top: 50%; width: 20px; height: 20px; background: url(../assets/outround1.png)no-repeat center; background-size: contain; position: absolute; transform: translate(-50%, -50%); animation: rotate .5s;}
.index-banner .content{position: absolute; right: 2%; top: 50%; transform: translateY(-55%); background: url(../assets/index-banner-text-bg.png)no-repeat center; width: 31.25%; max-width: 400px; z-index: 10; background-size: contain; height: 60%;}
.index-banner ul{padding: 0 0 0 10%; color: #fff;}
.index-banner .tit{font-size: 20px; word-break: break-word;}
.index-banner .num{font-size: 48px; padding: 2% 0 10%; font-family: 'GongfangYa'; font-weight: bold;}
.index-banner .num span{font-size: 18px;}
@keyframes rotate{
  100%{
    transform: translate(-50%,-50%) rotate(360deg);
  }
}
@media(max-width: 1200px){
  .index-banner .tit{font-size: 16px;}
  .index-banner .num{font-size: 40px;}
  .index-banner .num span{font-size: 15px;}
}
@media(max-width: 1024px){
  .index-banner{min-height: calc(100vw * .43);}
  .index-banner .pc{display: none;}
  .index-banner .wap{display: block; min-height: calc(100vw * .43)}
  .index-banner .content{display: none;}
}

.index{padding: 5% 0;}
.index ul{margin: -1% -1.875%;}
.index li{float: left; padding: 0 1.875%; margin: 2% 0; width: 33.3333%; position: relative; box-sizing: border-box;}
.index li::before{content: ''; position: absolute; width: 60%; height: 40%; left: 10px; top: -20px; border-top-left-radius: 70px;
/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+0,000000+100&0.65+0,0+100;Neutral+Density */
background: -moz-linear-gradient(-45deg,  rgba(228,0,127,0.3) 0%, rgba(0,0,0,0) 40%); /* FF3.6-15 */
background: -webkit-linear-gradient(-45deg,  rgba(228,0,127,0.3) 0%,rgba(0,0,0,0) 40%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(135deg,  rgba(228,0,127,0.3) 0%,rgba(0,0,0,0) 40%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a6000000', endColorstr='#00000000',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */

}
.index li::after{content: ''; transition: all .3s; position: absolute; width: 60%; height: 40%; right: 10px; bottom: -20px; border-bottom-right-radius: 70px; opacity: 0;
/* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#000000+0,000000+100&0.65+0,0+100;Neutral+Density */
background: -moz-linear-gradient(135deg,  rgba(228,0,127,0.8) 0%, rgba(0,0,0,0) 40%); /* FF3.6-15 */
background: -webkit-linear-gradient(135deg,  rgba(228,0,127,0.8) 0%,rgba(0,0,0,0) 40%); /* Chrome10-25,Safari5.1-6 */
background: linear-gradient(-45deg,  rgba(228,0,127,0.8) 0%,rgba(0,0,0,0) 40%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#a6000000', endColorstr='#00000000',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}
.index li:hover::after{opacity: 1;}
.index .pic{width: 100%; padding-top: 130%; border-radius: 70px 0; position: relative; z-index: -1; overflow: hidden;}
.index .pic .cover{position: absolute; width: 100%; height: 100%; top: 0; left: 0; background-color: rgba(228,0,127,0.1);}
.index .content{position: absolute; top: 0; left: 20px; padding: 8%; width: calc(100% - 20px);}
.index .tit{font-size: 36px; color: #fff; letter-spacing: 3px;}
.index .txt{font-size: 18px; color: #fff; padding-top: 3%; letter-spacing: 1px; line-height: 1.8;}
.index .more{font-size: 16px; color: #fff; font-weight: lighter; position: absolute; bottom: 6%; right: 12%; opacity: 0; transition: all .3s; z-index: 10; padding-right: 40px; background: url(../assets/more.png)no-repeat right center;}
.index li:hover .more{opacity: 1;}
@media(max-width: 1200px){
  .index .tit{font-size: 32px;}
}
@media(max-width: 960px){
  .index li{width: 50%; margin: 3% 0;}
  .index li::before{left: 0;}
  .index li::after{right: 0;}
  .index .tit{font-size: 28px;}
  .index .txt{font-size: 16px;}
  .index .more{font-size: 14px;}
}
@media(max-width: 640px){
  .index li{width: 100%;}
  .index li .more,
  .index li::after{opacity: 1;}
}
</style>
